import { motion } from 'framer-motion';

const FinalCTASection = () => {
  return (
    <section className="py-32 bg-stone-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-300 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-300 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {/* Main Message */}
          <h2 className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight">
            吉野、気になる。
            <br />
            でも何から?
          </h2>

          <p className="text-2xl md:text-3xl text-white/95 mb-6 font-bold">
            それ、いちばん健全な迷い方です
          </p>

          <p className="text-lg md:text-xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
            完璧な計画より、「気になる」という気持ち。それが、挑戦の第一歩です。
          </p>

          {/* CTA Button */}
          <motion.a
            href="/consultation"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-white hover:bg-gray-100 text-stone-700 px-12 py-6 rounded-lg text-xl md:text-2xl font-black transition-all shadow-2xl hover:shadow-3xl hover:-translate-y-1 whitespace-nowrap inline-flex items-center gap-4 cursor-pointer mb-8"
            aria-label="吉野なんでも相談所へ移動"
          >
            <i className="ri-chat-3-line text-3xl w-8 h-8 flex items-center justify-center" aria-hidden="true"></i>
            吉野なんでも相談所へ
          </motion.a>

          {/* Sub Info */}
          <div className="space-y-3">
            <p className="text-white/90 text-lg font-medium">
              決まってなくてOK
            </p>
            <p className="text-white/80 text-base">
              返信目安:2-3営業日
            </p>
          </div>

          {/* Additional Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-16 pt-12 border-t border-white/20"
          >
            <p className="text-white/90 text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
              相談内容に応じて、いちばん合う人につなぎます。長文いりません。「気になるテーマ・動けそうな時期・いまの状態」だけ教えてください。
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
